import styles from "@/pages/priceTagManage/index.module.less";
import {Tooltip} from "antd";

export const config = {
  fieldControl: false,
  tableType: 'antd',
  columns: [
    {title: '序号', dataIndex: 'sort', width: 120, render: 'sortRender'},
    {title: '费用名称', dataIndex: 'prodCateName', width: 200, render: 'nameRender', ellipsis: true},
    {title: '适用门店', dataIndex: 'orgName', width: 200, ellipsis: true},
    {title: '适用产品', dataIndex: 'productName', width: 200, ellipsis: true},
    {title: '计算配置', dataIndex: 'commonFormulaStr', width: 400, render: (v) => {
        return <Tooltip placement={"topLeft"} title={v} overlayInnerStyle={{minWidth: 100, maxWidth: 400}}>
          <div className={styles.overEllipsis}>{v}</div>
        </Tooltip>
      }},
    {title: '是否显示', dataIndex: 'showFlagStr', width: 120},
    {title: '是否比差', dataIndex: 'comparedSubFlagStr', width: 120, },
    {title: '是否可编辑', dataIndex: 'editFlagStr', width: 120, },
    {title: '开始日期', dataIndex: 'startDate', width: 180, itemType: 'date'},
    {title: '结束日期', dataIndex: 'endDate', width: 180, itemType: 'date'},
    {title: '操作', dataIndex: '#', width: 140, fixed: 'right', render: 'actionRender'},
  ],
  search: [
    {name: 'prodCateId', hidden: true},
    {
      label: '适用产品', name: 'productNameKey',
    },
    {
      label: '适用门店', name: 'orgId', itemType: 'custom', render: 'shopsRender',
    },
  ],
  footer: [
    {label: '导出', render: 'exportRender'},
    {label: '导入', render: 'importRender'},
    {label: '新增配置', type: 'primary', events: ['onClick:onAdd']},
  ],
  batchActions: [
    {
      label: '开始日期',
      // auth: 'priceButton4',
      danger: true,
      ghost: true,
      events: ['onClick:onBatchUpDateStart'],
    },
    {
      label: '结束日期',
      // auth: 'priceButton4',
      danger: true,
      ghost: true,
      events: ['onClick:onBatchUpDateEnd'],
    },
    {
      label: '删除',
      // auth: 'priceButton4',
      danger: true,
      ghost: true,
      events: ['onClick:onBatchDel'],
    }
  ]
}
